import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  alertTitleClasses,
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import pr from "../lib/pr";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import axios from "axios";
import get_token from "../lib/get_token";
import { configState } from "../lib/State";
import HomeHelpClass from './HomeHelpClass';
import get_cid from "../lib/get_cid";

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

const HomeCountPTCoupon = forwardRef((props, ref) => {
  const cid = get_cid();
  const history = useHistory();
  const { login } = props;
  const onCountClick = () => {
    if(login.mcd!=='') {
        history.push("/mypage?tab=2&cate=2");
    }
  };
  const [count, setCount] = useState('0');

  useImperativeHandle(ref, () => ({
    reload() {
      load_data();
    },
  }));

  const load_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(configState.api+"/gympass/home_count_pt", postData);
    setCount(result.data.count);
  };

  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    <Box
      sx={{
        width: "30%",
      }}
      
    >
      <ThemeProvider theme={typoTheme}>
        <Box
          sx={{ fontSize: "28px", fontFamily: "BebasNeue", color: "#0092a2" }}
          onClick={onCountClick}
        >
          { count }
        </Box>
      </ThemeProvider>
      <HomeHelpClass />
    </Box>
  );
})

export default HomeCountPTCoupon;
